import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import BaseNotification from 'modules/expenses/components/_Notification/Base'

const trackGoToPermissions = () => {
  track(trackingEvents.permissions.goToPermissions)
}
const trackDismissNotification = () => {
  track(trackingEvents.expenses.dismissSingleUseCardBannerNotification)
}

interface Props {
  canManageCompanyPermissions: boolean
}

const SingleUseCardNotification = ({ canManageCompanyPermissions }: Props) => {
  const [hasDismissedSingleUseCardBanner, setHasDismissedSingleUseCardBanner] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS.expensesHasDismissedSingleUseCardBanner, false)

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const dismissNotification = () => {
    trackDismissNotification()
    setHasDismissedSingleUseCardBanner(true)
  }

  const showSingleUseCardBanner = canManageCompanyPermissions && !hasDismissedSingleUseCardBanner

  if (!showSingleUseCardBanner) {
    return null
  }

  return (
    <BaseNotification
      description={i18n.t('expenses_v2.alerts.cards.create_single_use_card.description')}
      onClose={dismissNotification}
      closeLabel={i18n.t('expenses_v2.alerts.cards.create_single_use_card.cta_close')}
      type="info"
      title={i18n.t('expenses_v2.alerts.cards.create_single_use_card.title')}
      action={
        <Button
          type="secondary"
          onClick={() => {
            navigate(navigation.settings.permissions.fullPath())
            trackGoToPermissions()
          }}
        >
          {i18n.t('expenses_v2.alerts.cards.create_single_use_card.cta')}
        </Button>
      }
    />
  )
}

export default SingleUseCardNotification
